var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 36,
    viewBox: "0 0 182 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo-light-bg 1",
    clipPath: "url(#clip0_238_15781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_15781",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 182,
    height: 36
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_8_162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M181.893 0H0V35.8951H181.893V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_15781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.70537 0L0 5.86835H13.2492V35.3709H19.0292V5.86835H28.573L32.2783 0H3.70537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.5984 11.1356C33.6201 11.1356 31.7038 11.6494 30.0008 12.6315V11.1356H24.2242V35.3709H30.0008V22.6905C30.0008 19.5554 32.5123 17.0039 35.5984 17.0039H39.2212L42.9265 11.1321H35.5984V11.1356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M84.9104 11.1425L77.51 24.1864L70.0855 11.1425H63.442L77.51 35.8951L91.5539 11.1425H84.9104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.6048 14.6761L61.5944 14.6657C61.1919 14.2777 60.7034 13.8268 60.1426 13.4179L60.0806 13.3759C59.3272 12.8412 58.5531 12.4008 57.7136 12.0373C57.3007 11.8521 56.8741 11.7053 56.4475 11.5899C56.0484 11.4536 55.5874 11.3558 55.061 11.2859C54.6585 11.2125 54.2147 11.16 53.7502 11.1356H53.1619C49.8728 11.1356 47.031 12.3274 44.719 14.6761C42.407 17.0249 41.2338 19.9119 41.2338 23.2532C41.2338 25.8711 41.9942 28.2618 43.4976 30.3658C45.961 33.6862 49.2122 35.3709 53.1619 35.3709H65.0899V23.2532C65.0899 19.9119 63.9167 17.0249 61.6048 14.6761ZM59.3444 29.534L53.1619 29.527C51.4417 29.527 50.0173 28.9293 48.8097 27.706C47.5987 26.4513 47.0103 24.9973 47.0103 23.2532C47.0103 21.5092 47.5987 20.0587 48.8097 18.8249C50.0104 17.5806 51.4348 16.9794 53.1619 16.9794C54.889 16.9794 56.3133 17.5841 57.5209 18.8319C58.7457 20.0517 59.3375 21.4987 59.3375 23.2532L59.3444 29.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M123.093 0H117.319V35.287H123.093V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M181.893 0H176.12V12.8936C175.597 12.572 175.057 12.2854 174.489 12.0373C174.077 11.852 173.65 11.7052 173.223 11.5899C172.824 11.4536 172.363 11.3557 171.837 11.2858C171.434 11.2124 170.991 11.16 170.526 11.1355H169.938C166.649 11.1355 163.807 12.3274 161.495 14.6761C159.183 17.0249 158.01 19.9118 158.01 23.2532C158.01 25.8711 158.77 28.2617 160.274 30.3658C162.737 33.6862 165.988 35.3709 169.938 35.3709H181.866V35.2905H181.893V0ZM165.586 27.7025C164.375 26.4478 163.786 24.9938 163.786 23.2497C163.786 21.5056 164.375 20.0551 165.586 18.8214C166.786 17.5771 168.211 16.9759 169.938 16.9759C171.665 16.9759 173.089 17.5806 174.297 18.8284C175.522 20.0482 176.113 21.4951 176.113 23.2497L176.12 29.5305L169.938 29.5235C168.218 29.5235 166.793 28.9258 165.586 27.7025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M152.471 35.287H158.839L142.686 0.0140076L126.533 35.287H132.901L137.068 26.1891H148.304L152.471 35.287ZM139.751 20.3208L142.683 13.9177L145.614 20.3208H139.748H139.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M113.879 23.2567C113.879 23.0225 113.872 22.7883 113.858 22.5576C113.855 22.4912 113.848 22.4248 113.845 22.3619C113.834 22.1941 113.82 22.0229 113.803 21.8586C113.796 21.7922 113.79 21.7223 113.779 21.6559C113.759 21.4811 113.734 21.3099 113.704 21.1386C113.693 21.0862 113.686 21.0337 113.679 20.9813C113.642 20.7611 113.597 20.5409 113.545 20.3242C113.046 18.2132 111.983 16.3223 110.37 14.6831C108.058 12.3343 105.226 11.1425 101.954 11.1425C98.6825 11.1425 95.8028 12.3343 93.4909 14.6831C91.1789 17.0318 90.0057 19.9188 90.0057 23.2567C90.0057 26.5945 91.1789 29.4815 93.4909 31.8303C95.8028 34.179 98.6515 35.3709 101.954 35.3709H112.847L109.141 29.506H101.858C100.189 29.478 98.7857 28.8838 97.5781 27.678C96.3705 26.4512 95.7822 25.0042 95.7822 23.2567C95.7822 21.5091 96.3705 20.0621 97.5781 18.8353C98.8029 17.591 100.234 16.9864 101.954 16.9864C103.675 16.9864 105.096 17.6085 106.289 18.8388C106.75 19.3002 107.125 19.7965 107.407 20.3242H101.941L98.2352 26.1891H113.549C113.741 25.3712 113.848 24.5219 113.872 23.6376C113.876 23.5118 113.879 23.3825 113.879 23.2532V23.2567Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_15781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.13df1f6d727f79f5b74cac557eb3d2b2.svg";
export { ForwardRef as ReactComponent };